// Angular
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// RxJS
import { map } from 'rxjs/operators';

// Local
import { EmulationApiService } from '@app/services/api/emulation/emulation-api.service';
import { ROUTES } from '@routes';

/**
 * Guards the Emulate-a-User route against the same server-enforced capability that drives the nav
 * entry (`GET /emulation/enabled`). Redirects to /forbidden when the current user has no emulation
 * capability, so an internal user cannot deep-link into a picker they cannot use.
 */
export const canEmulateUser: CanActivateFn = () => {
  const router = inject(Router);
  const emulationApi = inject(EmulationApiService);

  return emulationApi
    .getEnabled()
    .pipe(
      map(enabled => (enabled ? true : router.parseUrl(`/${ROUTES.FORBIDDEN}`))),
    );
};
